export default {
    la : {
        width: '230px',  
        textAlign: 'left'
    },

    age_la : {
        width: '85px',  
        textAlign: 'right'
    },

    average_la : {
        width: '90px',  
        textAlign: 'right'
    },

    panel : {
        maxWidth:'750px',
        width:'550px',
        minHeight:'70px',
        maxHeight:'520px',
        paddingTop:'2px',
        paddingBottom:'0'
    },

    table : {
        width: '480px'
    },

    tableHeader: { 
		textAlign:'left'
    }
}


// WEBPACK FOOTER //
// ./src/containers/season/components/Styles/divisions.js